import {keycloak} from './keycloak';

export const getKeycloakToken = async (): Promise<string | null> => {
  if (!keycloak.authenticated) {
    return null;
  }

  try {
    const refreshedToken = await keycloak.updateToken(30); // Refresh token if it's older than 30 seconds
    if (refreshedToken) {
      console.log('Keycloak token refereshed successfully');
    }
    return keycloak.token ?? null; // Return the refreshed token or null if undefined

} catch (error) {
    console.error('Failed to refresh Keycloak token:', error);
    return null;
  }


};